import React from 'react';

import Server from '../../../services/Server';

class SettingsStreamControls extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
		};

		this.sendCommand = this.sendCommand.bind(this);
		this.checkStatus = this.checkStatus.bind(this);

		this.mounted = true;
	}
	componentDidMount() {
		this.mounted = true;
		if (this.props.live_stream !== undefined) {
			if (this.props.live_stream.id !== undefined) {
				this.setState(
					{ stream: this.props.live_stream.id, isLoading: false },
					() => {
						this.checkStatus();
					}
				);
			}
		}
	}
	componentWillUnmount() {
		this.mounted = false;
	}
	componentWillReceiveProps(ns) {
		if (this.props.live_stream.id !== ns.live_stream.id) {
			this.setState({ stream: ns.live_stream.id, isLoading: false }, () => {
				this.checkStatus();
			});
		}
	}

	checkStatus(newTimeout) {
		if (this.mounted) {
			newTimeout = newTimeout === undefined ? true : newTimeout;

			Server.events
				.getStatus(this.props.videoServer, this.state.stream, this.props.id)
				.then((response) => {
					this.props.setStatus(response.data.live_stream.state);
					const _time =
						response.data.live_stream.state.substr(-3) === 'ing' ? 1000 : 90000;
					if (newTimeout) {
						setTimeout(this.checkStatus, _time);
					}
				})
				.catch(() => {
					this.props.setStatus('not_responding');
					if (newTimeout) {
						setTimeout(() => {
							this.checkStatus();
						}, 30000);
					}
				});
		}
	}

	sendCommand(e, command) {
		if (!this.props.isBlocked) {
			const self = this,
				iconControl = e.currentTarget.childNodes[0],
				{ stream } = this.state;

			const { videoServer, id } = this.props;

			iconControl.classList.toggle('rotate');
			iconControl.classList.toggle('loading');

			this.setState({ isLoading: true }, () => {
				Server.events
					.streamControl(videoServer, stream, command, id)
					.then((response) => {
						if (response.status === 200) {
							const { data = {} } = response,
								{ livestream = {} } = data,
								{ state = 'loading' } = livestream;

							self.props.setStatus(state);
							setTimeout(() => {
								self.checkStatus(state.substr(-3) === 'ing');
							}, 2000);
						} else {
							self.props.setStatus('not_responding');
						}

						self.setState({ isLoading: false }, () => {
							iconControl.classList.toggle('rotate');
							iconControl.classList.toggle('loading');
						});
					})
					.catch(() => {
						self.setState({ isLoading: false }, () => {
							iconControl.classList.toggle('rotate');
							iconControl.classList.toggle('loading');
						});
					});
			});
		}
	}

	render() {
		const { status, isBlocked } = this.props,
			{ isLoading } = this.state,
			canNotStart = status === 'started' || status.substr(-3) === 'ing',
			canNotStop = status === 'stopped' || status.substr(-3) === 'ing',
			canNotReset = status === 'stopped' || status.substr(-3) === 'ing';

		return (
			<div>
				<button
					onClick={(e) => this.sendCommand(e, 'start')}
					className="btn btn-outline-primary"
					disabled={isLoading || canNotStart || isBlocked}
				>
					<i className="fas fa-play"></i>
					<span> Iniciar</span>
				</button>
				<button
					onClick={(e) => this.sendCommand(e, 'stop')}
					className="btn btn-outline-danger"
					disabled={isLoading || canNotStop || isBlocked}
				>
					<i className="fas fa-stop"></i>
					<span> Detener</span>
				</button>
				<button
					onClick={(e) => this.sendCommand(e, 'reset')}
					className="btn btn-outline-info"
					disabled={isLoading || canNotReset || isBlocked}
				>
					<i className="fas fa-retweet"></i>
					<span> Reiniciar</span>
				</button>
			</div>
		);
	}
}

export default SettingsStreamControls;
